import axios from "axios";
import { setAlert } from "./alert";
import {
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_ERROR,
  GET_SETTINGS_LIST,
  GET_SETTINGS_LIST_ERROR,
} from "./types";

export const getSettingsData = () => async (dispatch) => {
  try {
    const res = await axios.get(process.env.REACT_APP_SITE_URL + "/v2/updateSettings");
    dispatch({
      type: GET_SETTINGS_LIST,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_SETTINGS_LIST_ERROR,
    });
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    return errors;
  }
};

export const updateSettingsData = (data) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(process.env.REACT_APP_SITE_URL + "/v2/updateSettings", data, config);

    dispatch({
      type: UPDATE_SETTINGS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: UPDATE_SETTINGS_ERROR,
    });
    return errors;
  }
};

export const getSettingsAll = () => async (dispatch) => {
  

  try {
    const res = await axios.get(process.env.REACT_APP_SITE_URL + "/v2/users/getPolicies");

    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    return errors;
  }
};
